
import axios from 'axios'
import ArrayFrom from 'array-from'

export default {
  init() {
    class Integrations {
      constructor(el) {
        this.el = el
        
        var searchable = ArrayFrom(this.el.querySelectorAll('[data-search]'))
        searchable.forEach((search) => {
          search.addEventListener('keyup', () => {
            this.searchTerm = search.value
            this.displayTable(this.data)
          })
        })

        this.fetch(this.getType(), (data) => {
          this.data = this.formatData(data)
          this.displayTable(this.data)
        })
      }

      getType() {
        return this.el.getAttribute('data-type') || 'OTA'
      }

      formatData(data) {
        var formatted = []
        // Delete the headings row
        delete data[0]

        // Format each row into an object
        data.forEach((row) => {
          formatted.push({
            title: row[1],
            url: row[2],
            status: row[4],
          })
        })
        return formatted
      }

      fetch(type, callback) {
        let integrationsKey = 'AIzaSyBOaGyom1MdJvbv6tnvHi6UP1TZn-FWOrU' // GoogleAPI Key
        let spreadsheetID = '1W5mIIy9yG9ddQ887ReZW4VJJiONIhPs0SU-qBIoPeVM' // ID of Google doc spreadsheet
        let URL = 'https://sheets.googleapis.com/v4/spreadsheets/' + spreadsheetID + '/values/' + type + '?key=' + integrationsKey
        axios.get(URL)
          .then(function (response) {
            callback(response.data.values)
          }).catch(function (response) {
            console.error('Unable to contact servers. Please come back and try again later.', response)
          })
      }

      displayTable(data) {

        var stage = this.el.querySelector('.channel-integration-data')
        stage.setAttribute('aria-busy', true)

        if (this.searchTerm) {
          data = this.filter(data, this.searchTerm)
        }

        // Default sort (A - Z) by title
        if (!this.sortTerm) {
          this.sortTerm = {
            by: 'title',
            dir: 'ASC',
          }
        }
        data = this.sort(data, this.sortTerm.by, this.sortTerm.dir)

        // Create the headings
        var thead = (() => {
          var thead = document.createElement('thead')
          var headings = ['title', 'status', 'cta']
          var row = thead.insertRow()
          for (let i = 0; i < headings.length; i++) {
            let cell = document.createElement('th')
            let integrationTranslations = window.integrationTranslations
            // Add the text content (if there's a translation available)
            if (integrationTranslations.headings[headings[i]]) {
              cell.textContent = integrationTranslations.headings[headings[i]]
            }

            // Set the sorting key
            cell.setAttribute('data-sort', headings[i])

            // Set the up / down sorting arrows
            if (this.sortTerm.by === headings[i]) {
              cell.setAttribute('data-direction', this.sortTerm.dir)
            }

            row.appendChild(cell)
          }

          thead.appendChild(row)
          return thead
        })()

        // Create the body
        var tbody = (() => {
          var tbody = document.createElement('tbody')
          for (let i = 0; i < data.length; i++) {
            let rowTitle = data[i].title
            let rowUrl = data[i].url
            let utm = ''
            if (rowUrl.includes('?')) {
              utm = '&utm_source=www.siteminder.com&utm_medium=referral&utm_campaign=Integrations&utm_content=textlink'
            } else {
              utm = '?utm_source=www.siteminder.com&utm_medium=referral&utm_campaign=Integrations&utm_content=textlink'
            }
            let rowStatus = data[i].status

            // Create table row and individual cells(td)
            let row = tbody.insertRow()
            let cellTitle = row.insertCell(0)
            let cellStatus = row.insertCell(1)
            let cellButton = row.insertCell(2)
            cellTitle.innerHTML = rowTitle

            let integrationTranslations = window.integrationTranslations
            var status = integrationTranslations.status
            let statusComingSoon = status.comingSoon
            let statusLive = status.live
            let statusNew = status.new
            let statusCtaText = status.ctaText

            // Check integration Status
            if (rowStatus == 'COMING SOON') {
              cellStatus.innerHTML = '<span class="btn label btn-sm btn-primary">' + statusComingSoon + '</span>'
            } else if (rowStatus == 'NEW') {
              cellStatus.innerHTML = '<span class="btn label btn-sm">' + statusLive + '</span> <span class="btn label btn-sm btn-warning">' + statusNew + '</span>'
            } else {
              cellStatus.innerHTML = '<span class="btn label btn-sm">' + statusLive + '</span>'
            }
            cellStatus.className = 'integrations-status'
            if (rowUrl == '') {
              cellButton.innerHTML = '<a class="btn btn-sm btn-primary disabled">' + statusCtaText + '</a>'
            } else if (rowUrl.indexOf('mailto:') === 0) {
              cellButton.innerHTML = '<a href="' + rowUrl + utm + '" target="_blank" class="btn btn-sm btn-primary">' + statusCtaText + '</a>'
            } else {
              cellButton.innerHTML = '<a href="http://' + rowUrl + utm + '" target="_blank" class="btn btn-sm btn-primary btn-outlined">' + statusCtaText + '</a>'
            }
            cellButton.className = 'integrations-cta'
          }
          return tbody
        })()

        // Create the footer
        var tfoot = (() => {
          var tfoot = document.createElement('tfoot')
          let count = data.length
          let total = this.data.length
          let row = tfoot.insertRow()
          let cell = row.insertCell(0)
          let integrationTranslations = window.integrationTranslations
          var summary = integrationTranslations.summary
          cell.innerHTML = summary
          cell.textContent = summary.replace('[count]', count).replace('[total]', total)
          return tfoot
        })()

        stage.innerHTML = ''
        stage.appendChild(thead)
        stage.appendChild(tbody)
        stage.appendChild(tfoot)
        stage.setAttribute('aria-busy', false)

        this.bind()
      }


      filter(data, by) {
        by = by.toLowerCase()
        var filtered = []
        data.forEach((row) => {
          let compare = row.title.toLowerCase()
          if (compare.indexOf(by) >= 0) {
            filtered.push(row)
          }
        })
        return filtered
      }

      sort(data, by, dir) {
        function Comparator(a, b) {
          let aVal = (a[by] || '').toString().toLowerCase();
          let bVal = (b[by] || '').toString().toLowerCase();
          if (aVal < bVal) return -1;
          if (aVal > bVal) return 1;
          return 0
        }

        data = data.sort(Comparator)

        if (dir === 'DESC') {
          data = data.reverse()
        }

        return data
      }

      bind() {
        var sortable = ArrayFrom(this.el.querySelectorAll('[data-sort]'))
        sortable.forEach((sort) => {
          sort.addEventListener('click', () => {
            // Get the direction
            var direction = 'ASC'
            if (sort.getAttribute('data-direction') === 'ASC') {
              direction = 'DESC'
            }

            // Set the sorting term
            this.sortTerm = {
              by: sort.getAttribute('data-sort'),
              dir: direction,
            }
            this.displayTable(this.data)
          })
        })
      }
    }

    const instances = ArrayFrom(document.querySelectorAll('.channel-integration'))
    instances.forEach((instance) => {
      return new Integrations(instance)
    })
  },
    finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/channelIntegration.js